
import Vue from "vue";
import Auth from "@/lib/Auth";
import Api from "@/services/Api";
import { Login } from "@/models/Login";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";
import { Overlay } from "@/lib/Overlay";
import router from "@/router";
import VueRecaptcha from "vue-recaptcha";
import { DeviceUUID } from "device-uuid";
import LocaleSwitcher from "../../components/LocaleSwitcher.vue";

export default Vue.extend({
  name: "Login",
  data: () => ({
    rand: 1,
    isMobile: false,
    windowOverlay: false,
    dialog2FALogin: false,
    dialogSelectAccount: false,
    uriLogin: "/v2/client/auth",
    showpass: false,
    valid: true,
    form: { banprime: null } as Login,
    loginError: null,
    passwordError: null,
    btnLoading: false,
    lembraLogin: false,
    hasRegisteredDevice: false,
    clientIp: "0.0.0.0",
    deviceInfo: {},
    selectedBanPrimeAccount: {} as any,
    banPrimeAccounts: [{
      "createdAt": "2024-09-18 09:45:41",
      "updatedAt": "2025-03-28 05:12:08",
      "status": "ACTIVE",
      "personType": "J",
      "documentNumber": "11935552000108",
      "fullName": "INVIZZA SERVICOS DE AUTOMACAO LTDA",
      "accountBranchNumber": "0001",
      "accountNumber": "4352",
      "accountNumberDigit": "1",
      "modalityId": "14",
      "modalityDescription": "CONTA DE PAGAMENTO EZZEBANK - PJ"
    },
    {
      "createdAt": "2025-02-13 10:11:59",
      "updatedAt": "2025-02-13 11:29:46",
      "status": "ACTIVE",
      "personType": "J",
      "documentNumber": "11935552000108",
      "fullName": "INVIZZA SERVICOS DE AUTOMACAO LTDA",
      "accountBranchNumber": "0001",
      "accountNumber": "4373",
      "accountNumberDigit": "7",
      "modalityId": "14",
      "modalityDescription": "CONTA DE PAGAMENTO EZZEBANK - PJ"
    }] as any,
    isBanPrime: false,
    tokenBanPrime: "",
    sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    // sitekey: process.env.VUE_APP_DEVELOPMENT_RECAPTCHA_SITE_KEY,
  }),
  components: {
    "vue-recaptcha": VueRecaptcha,
    LocaleSwitcher: LocaleSwitcher,
  },
  created() {
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("userAvatar");
    sessionStorage.removeItem("deviceRegisterData");
    this.form.code = "";

    this.isMobile = this.detectMobile();
    if (
      sessionStorage.deviceRegistered == undefined ||
      sessionStorage.deviceRegistered == null
    ) {
      this.hasRegisteredDevice = false;
    } else {
      this.hasRegisteredDevice = true;
    }

    this.rand = new Date().getTime();
    if (localStorage.getItem("lembrarDadosAcesso")) {
      const dadosAcesso = JSON.parse(
        String(localStorage.getItem("lembrarDadosAcesso"))
      );
      this.form.login = dadosAcesso.login;
      this.form.lembrar = true;
      this.lembraLogin = true;
      this.form.dadosLembrar = JSON.parse(
        String(localStorage.getItem("lembrarDadosAcesso"))
      );
      // this.form.login= this.dadosLoginLembrar.login;
      // console.log(this.form.dadosLembrar.avatar);
    }

    this.form.tenant = this.$store.state.tenant.name;
    this.getUserIP();
    this.form.banprime = null;
    console.log(this.form.banprime);
  },

  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    randomNumber: function () {
      return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    },
    removeLembrar() {
      localStorage.removeItem("lembrarDadosAcesso");
      (this.form.login = ""), (this.lembraLogin = false);
    },
    doLogin(token: string): void {
      this.btnLoading = true;
      Overlay.show();

      if (this.isBanPrime) {
        this.form.banprime = {
          token: this.tokenBanPrime,
          accountNumber: this.selectedBanPrimeAccount.accountNumber,
          accountBranchNumber: this.selectedBanPrimeAccount.accountBranchNumber
        };
      }

      const _form = {... this.form};    

      if(this.$store.state.tenant.username.login === 'CPF') {
        _form.login = _form.login?.replace(/[^0-9]/g, "");
      }

      Api.post(this.uriLogin, _form, {
        headers: {
          recaptcha: token,
        },
      })
        .then((response) => {
          // console.log(response);
          Overlay.show();

          sessionStorage.setItem(
            "userData",
            btoa(JSON.stringify(response.data.body.dados))
          );

          //se o dispositivo nao estiver registrado....
          if (!response.data.body.device_info.hasDispositivoDB) {
            /* sessionStorage.setItem(
                "pre_access_token",
                response.data.body.token
              );*/
            sessionStorage.setItem(
              "deviceRegisterData",
              JSON.stringify(response.data.body.device_info)
            );
            router.push("/device");
          } else {
            if (this.form.lembrar) {
              localStorage.setItem(
                "lembrarDadosAcesso",
                JSON.stringify({
                  login: this.form.login,

                  nome: response.data.body.dados.nome,
                  avatar: response.data.body.dados.txtAvatar,
                })
              );
            } else {
              localStorage.removeItem("lembrarDadosAcesso");
            }

            sessionStorage.setItem(
              "userAvatar",
              response.data.body.dados.avatar
            );

            sessionStorage.setItem(
              "_vid",
              response.data.body.device_info.hashDevice
            );
            sessionStorage.removeItem("deviceRegistered");
            Auth.login(response.data.body.token);
          }
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          this.form.code = "";
          if (status === 422) {
            if (data.body.errors.login)
              this.loginError = data.body.errors.login;
            if (data.body.errors.password)
              this.passwordError = data.body.errors.password;
          } else if (status === 302) {
            this.$nextTick(() => {
              const wrapper = this.$refs.code as any;

              window.setTimeout(() => wrapper?.focus(), 0);
            });
            this.uriLogin = "/v2/client/auth/2fa";
            this.dialog2FALogin = true;
          } else if (status === 300) {
            this.$nextTick(() => {


              this.isBanPrime = true;
              this.tokenBanPrime = response.data.body.token;
              this.banPrimeAccounts = response.data.body.accounts;
            
              this.uriLogin = "/v2/client/auth/bp";
              this.dialogSelectAccount = true;


            });

          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
          this.resetRecaptcha();
        })
        .finally(() => {
          this.btnLoading = false;
          //  console.log("finalizou");

          Overlay.hide();
        });
    },
    onSubmit: function () {
      //this.windowOverlay = true;

      (this.$refs.invisibleRecaptcha as HTMLFormElement).execute();
    },
    onVerify: function (response: string) {
      this.doLogin(response);
    },
    onExpired: function () {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      (this.$refs.invisibleRecaptcha as HTMLFormElement).reset(); // Direct call reset method
    },
    cancela2FA() {
      this.uriLogin = "/v2/client/auth";
      this.form.code = "";
      this.dialog2FALogin = false;
      this.form.password = "";
      this.dialogSelectAccount = false;

    },

    getUserIP: function () {
      const uuid = new DeviceUUID().get();
      if (
        localStorage.MachineId == undefined ||
        localStorage.MachineId == null
      ) {
        localStorage.setItem("MachineId", uuid);
      }

      this.form.deviceInfo = {
        useragent: navigator.userAgent,
        deviceId: uuid,
        lat_long: "",
        imei: "",
        mac: "",
      };
      /*
      Overlay.show();
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((response) => {
          this.form.deviceInfo = {
            useragent: navigator.userAgent,
            //ip: response.ip,
            lat_long: "",
            imei: "",
            mac: "",
          };

        })
        .finally(() => {
          Overlay.hide();
        });
         */
    },
    verifyWritePass() {
      if (this.form.password != "") {
        this.showpass = false;
        this.passwordError = null;
      }
    },
    verifyWriteEmail() {
      if (this.form.login != "") {
        this.loginError = null;
      }
    },
  },
});
